import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ElementMouseEvent} from 'util/Types';

export interface DigestProps {
  /** Whether to disable deleting this digest */
  disableDelete: boolean;
  /** A comma-separated list of names of enzymes contained in this restriction digest */
  enzymeNamesDisplay: string;
  /** The name of the digest analysis */
  name: string;
  /** A function to be called when this item is clicked */
  onClick: () => void;
  /** A function to be called when this item is deleted */
  onClickDelete: () => void;
}

export default function DigestLibraryItem({
  disableDelete,
  enzymeNamesDisplay,
  name,
  onClick,
  onClickDelete,
}: DigestProps): JSX.Element {
  return (
    <tr className={css(styles.wrapper)} onClick={onClick}>
      <td className="name">{name}</td>
      <td>
        {enzymeNamesDisplay}
        {!disableDelete && (
          <span
            className="glyphicon glyphicon-trash delete pull-right"
            onClick={(e: ElementMouseEvent) => {
              e.stopPropagation();
              onClickDelete();
            }}
          />
        )}
      </td>
    </tr>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    cursor: 'pointer',
  },
});
